export { default } from "./Info";
export { default as infoReducer } from "./slice";
export { useInfo } from "./hooks";
